<template>
  <v-card
    class="mx-auto pb-3"
    :loading="agencyLoading"
    flat
  >
    <v-toolbar dense flat>
      <v-toolbar-title class="flex text-center">
        Đơn vị quản lý
      </v-toolbar-title>
    </v-toolbar>
    <v-card-text class="scroll-custom-primary" 
      :class="$style.agencyList">
      <v-list dense>
        <v-list-item
            v-for="(agency, index) in agencies"
          :key="index"
        >
          <v-list-item-avatar>
            <v-img
              v-if="agency.logo"
              :src="`${apiBaseUrl}/uploads/${agency.logo}`"
              lazy-src="@/assets/NoImage.jpg"
            />
            <v-img v-else src="@/assets/tglogo.png"/>
          </v-list-item-avatar>
          <v-list-item-content>
            <div class="text-subtitle-1 font-weight-medium primary--text">
              {{agency.ten_donvi}}
            </div>
            <v-list-item-subtitle>
              <div class="text-body-2">
                <v-icon small>
                  mdi-map-marker-outline
                </v-icon>
                {{agency.dia_chi}}
              </div>
              <div class="text-body-2">
                <v-icon small>
                  mdi-phone
                </v-icon>
                {{agency.so_dien_thoai}}
              </div>
              <div class="text-body-2">
                <v-icon small>
                  mdi-email-outline
                </v-icon>
                {{agency.email}}
              </div>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-pagination
        v-if="totalPages > 1"
        class="mt-4"
        v-model="currentPage"
        :length="totalPages"
        @input="handlePageChange"
      />
    </v-card-text>
  </v-card>
</template>
<script>
  import { mapState } from 'vuex';
  export default {
    name: "Agency",
    data() {
      return {
        agencyLoading: false,
        agencies: [],
        currentPage: 1,
        totalItems: 0,
        totalPages: 0
      };
    },
    computed: {
      ...mapState([
        'config'
      ]),
      apiBaseUrl() {
        return this.config.beUrl;
      }
    },
    mounted(){
      this.getAgencies();
    },
    methods: {
      getRequestParams(page) {
        let params = {};

        if (page) {
          params["page"] = page;
        }
        params["size"] = 10;

        return params;
      },
      handlePageChange(value) {
        this.currentPage = value;
        this.getAgencies();
      },
      getAgencies(){
        this.agencyLoading = true;
        const params = this.getRequestParams(
          this.currentPage,
        );
        let request = {
          params: params
        };
        axios.get("api/v1/public/managements", request)
          .then(response => {
            this.agencies = response.data.data;
            this.totalItems = response.data.total;
            const caluTotalPage = response.data.total/response.data.per_page;
            this.totalPages = Math.ceil(caluTotalPage);
            this.agencyLoading = false;
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    }
  };
</script>
<style module>
  .agencyList {
    height: 400px; 
    overflow-y: scroll;
  }
</style>